import FBMultiArrest from './container/MultiArrestLanding';

export default FBMultiArrest;
